<template>
    <v-menu
        :value="menuState"
        :return-value="false"
        v-bind="menuProps"
        :max-width="maxWidth ? maxWidth : 'auto'"
        :content-class="removable && hideMenu ? 'elevation-0 overflow-y-hidden dropmenu rounded-lg' : 'overflow-y-hidden dropmenu rounded-lg'"
        style="overflow-y: hidden !important"
        :offset-x="openOnRight"
        :nudge-top="openOnRight?'38':''"
        @input="updateMenuState($event)"
    >
        <template v-slot:activator="{ on }">
            <slot :on="on" />
        </template>
        <slot name="content">
            <v-card
                v-if="!hideMenu"
                class="ma-0 pa-0"
                :style="computed_min_width_style_string"
                style="max-height: 100%;"
            >
                <v-card-title
                    v-if="menuTitle"
                    class="ma-0 py-2 px-4"
                    style="border-bottom: 1px solid lightgrey"
                >
                    <span class="font-weight-regular">{{ menuTitle }}</span>
                </v-card-title>
                <v-card-title class="ma-0 pa-0" @click.stop="">
                    <v-text-field
                        v-show="searchable"
                        ref="selectsearch"
                        v-model="search"
                        :placeholder="searchText"
                        :color="color"
                        hide-details
                        single-line
                        shaped
                        outlined
                        :autofocus="autoFocus"
                        class="mt-0 pt-0 search-field"
                        clearable
                        clear-icon="mdi-close"
                        @click:clear="clearSearch"
                    >
                        <template slot="append">
                            <v-icon
                                v-show="!search"
                                size="16"
                                color="grey"
                                style="margin-top: 3px"
                                class="mr-2"
                            >
                                mdi-magnify
                            </v-icon>
                        </template>
                    </v-text-field>
                </v-card-title>
                <v-card-text
                    class="ma-0 pa-0 py-2 x-borders"
                    style="overflow: auto; max-height: 333px;"
                >
                    <div class="d-flex justify-center" v-if="isLoading">
                        <LoaderDefault
                            :size="24"
                            :width="2"
                        />
                    </div>
                    <v-list class="py-0" v-else>
                        <v-list-item
                            v-for="(item, index) in itemsCopy"
                            :key="index"
                            dense
                            class="menu-list-item menu-list-item v-list-item v-list-item--dense v-list-item--link theme--light"
                            :class="textColor"
                            :ripple="false"
                            :style="{ computed_min_width_style_string, minHeight: '32px' }"
                            style="height: 32px;"
                            tabindex="0"
                            @click.stop="select(item)"
                        >
                            <div style="display: contents">
                                <slot
                                    name="item-avatar"
                                    :item="item"
                                >
                                    <v-list-item-avatar
                                        v-if="avatars && item[avatarInitialsKey]"
                                        size="24"
                                        :tile="avatarCircularRuleFunc(item)"
                                        :class="item.type === 'group' || item.type === 'field' ? 'uku-{0}-avatar'.format(item.type) : ''"
                                        :color="
                                            !!item[avatarKey] ? 'white' : item.type === 'group' || item.type === 'field' ? 'white--text' : item[colorKey] ? item[colorKey] : 'grey lighten-2 blue-grey--text text--darken-1'
                                        "
                                    >
                                        <img
                                            v-if="item[avatarKey]"
                                            :src="item[avatarKey]"
                                        />
                                        <span
                                            v-else
                                            class="font-weight-medium"
                                            style="font-size: 10px"
                                            :class="[item[avatarInitialsClassKey], avatarInitialsClass]"
                                        >
                                            {{ item[avatarInitialsKey] }}
                                        </span>
                                    </v-list-item-avatar>
                                </slot>
                                <v-list-item-icon v-if="item[iconKey]">
                                    <v-icon :color="iconColor">
                                        {{ item[iconKey] }}
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title
                                        :class="isSelected(item) ? 'font-weight-bold' : ''"
                                        :style="capitalize ? 'text-transform:capitalize' : ''"
                                    >
                                        <slot
                                            :item="item"
                                            name="tile-content"
                                        >
                                            {{ itemName(item) }}
                                        </slot>
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action
                                    v-if="enableHoverAction"
                                    class="ma-0 pa-0"
                                >
                                    <v-btn
                                        icon
                                        right
                                        class="hover-action ma-0"
                                        @click.stop="hoverAction(item)"
                                    >
                                        <v-icon
                                            small
                                            :color="color"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                                <v-list-item-action v-else>
                                    <v-icon
                                        v-show="isSelected(item)"
                                        :color="color"
                                        style="margin-top:-5px"
                                    >
                                        {{ icon }}
                                    </v-icon>
                                </v-list-item-action>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions
                    v-show="(itemsCopy.length > 0 && toggleSelect && multi && deselect && !hideSelectAll) || isActionsSlotUsed || showActionsSlot"
                    class="ma-0 x-borders"
                    style="border-top: 1px solid lightgrey"
                >
                    <slot name="actions">
                        <div class="mr-2">
                            <a
                                class="px-1 pl-2 primary--text text--darken-2 caption font-weight-medium"
                                style="white-space:nowrap; text-decoration: none"
                                @click.stop="toggleAllSelected"
                            >
                                {{ $t("All") }}
                            </a>
                            <span class="divider g4--text">|</span>
                            <a
                                class="px-1 primary--text text--darken-2 caption font-weight-medium"
                                style="white-space:nowrap; text-decoration: none"
                                @click.stop="toggleAllUnselected"
                            >
                                {{ $t("None filter") }}
                            </a>
                        </div>
                        <div
                            v-show="itemsCopy.length === 0"
                            class="white px-3 py-2"
                        >
                            <span class="grey--text text--darken-2 body-2">No results</span>
                        </div>
                        <v-btn
                            v-if="showConfirmButton"
                            color="primary"
                            class="ml-auto"
                            @click="onConfirmClick"
                        >
                            <span>{{ $t("OK") }}</span>
                        </v-btn>
                    </slot>
                </v-card-actions>
            </v-card>
        </slot>
    </v-menu>
</template>

<script>
/*
 *
 *  This is a modified copy of the original Pieces/DropMenu.vue file. Due to parallel development.
 *
 */

import DropMenuList from "../components/DropMenuList";
import { $t } from "@/i18n";
import { deepClone } from "@/helpers/helpers";
import LoaderDefault from '../../LoaderDefault.vue'

export default {
    name: "DropMenu",
    components: { DropMenuList, LoaderDefault },
    filters: {},
    props: {
        filterKey: {
            type: String,
            default: ""
        },
        strings: {
            type: Object,
            default: () => {
                return {
                    toggle: $t("select/unselect all")
                };
            }
        },
        removable: {
            type: Boolean,
            default: false
        },
        showSelectedFirst: {
            type: Boolean,
            default: true
        },
        hideMenu: {
            type: Boolean,
            default: false
        },
        menuTitle: {
            type: String,
            default: ""
        },
        openOnHover: {
            type: Boolean,
            default: false
        },
        avatars: {
            type: Boolean,
            default: false
        },
        toggleSelect: {
            type: Boolean,
            default: true
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        value: {
            type: [Array],
            default: () => []
        },
        items: {
            type: [Array, Object, Function],
            required: true
        },
        multi: {
            type: Boolean,
            default: false
        },
        hideSelectAll: {
            type: Boolean,
            default: false
        },
        showConfirmButton: {
            type: Boolean,
            default: true
        },
        deselect: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default: "mdi-check"
        },
        color: {
            type: String,
            default: "primary"
        },
        textColor: {
            type: String,
            default: "grey--text text--darken-2"
        },
        valueKey: {
            type: String,
            default: ""
        },
        nameKey: {
            type: String,
            default: ""
        },
        colorKey: {
            type: String,
            default: ""
        },
        iconColor: {
            type: String,
            default: "grey"
        },
        avatarKey: {
            type: String,
            default: ""
        },
        avatarInitialsClass: {
            type: String,
            default: ""
        },
        avatarInitialsClassKey: {
            type: String,
            default: "initials_class"
        },
        avatarCircularRuleFunc: {
            type: Function,
            default: () => false
        },
        iconKey: {
            type: String,
            default: ""
        },
        avatarInitialsKey: {
            type: String,
            default: "initials"
        },
        menuHeight: {
            type: Number,
            default: 300
        },
        searchable: {
            type: Boolean,
            default: false
        },
        searchText: {
            type: String,
            default: () => $t('Search')
        },
        searchValue: {
            type: String,
            default: ''
        },
        reverseSelect: {
            type: Boolean,
            default: false
        },
        menuMinWidth: {
            type: Number,
            default: 170
        },
        capitalize: {
            type: Boolean,
            default: false
        },
        menuProps: {
            type: Object,
            default: () => ({ "offset-y": true })
        },
        onChangeFunc: {
            type: Function,
            default: () => []
        },
        customRules: {
            type: Function,
            default: null
        },
        enableHoverAction: {
            type: Boolean,
            default: false
        },
        hoverAction: {
            type: Function,
            default: () => {
            }
        },
        openOnRight: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        },
        showLabelCountFrom: {
            type: String,
            default: "2"
        },
        menuState: {
            type: Boolean,
            default: false
        },
        autoFocus: {
            type: Boolean,
            default: true
        },
        currentAccountId: {
            type: Number,
            default: null
        },
        loading: {
            type: [Function, Boolean],
            default: false
        },
        showActionsSlot: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            search: "",
            valueCopy: [],
            itemsCopy: []
        };
    },
    computed: {
        computed_items() {
            if (this.isFunction(this.items)) {
                return this.items();
            } else {
                return this.items;
            }
        },
        computed_height() {
            if (this.toggleSelect && this.multi && this.deselect && this.itemsCopy.length > 0) {
                return "max-height:" + this.menuHeight + "px; overflow: auto; margin-bottom: 38px;";
            } else {
                return "max-height:" + this.menuHeight + "px; overflow: auto;";
            }
        },
        computed_min_width_style_string() {
            return "min-width:" + this.menuMinWidth + "px;";
        },
        isActionsSlotUsed() {
            // Why does this not work
            return this.$slots.actions;
        },
        isLoading() {
            if(this.isFunction(this.loading)) {
                return this.loading()
            } else {
                return this.loading
            }
        }
    },
    watch: {
        search() {
            this.itemsCopy = this.getFilteredAndSortedItems(this.computed_items)
        },
        searchValue(new_val, prev_val) {
            this.search = this.searchValue
        },
        value(val) {
            // necessary if value changes outside of this component
            this.updateFriendlyLabel(val)
        },
        computed_items: {
            immediate: true,
            handler: function (val) {
                // Dont re-render items when menu is open, otherwise flickering occurs
                // if(this.menuState) return
                this.itemsCopy = deepClone(val)
            }, deep: true
        },
        menuState(new_val, prev_val) {
            function wasMenuClosed(){
                return !new_val && !!prev_val
            }
            function wasMenuOpened(){
                return !!new_val && !prev_val
            }
            const getSearchInput = () => {
                return this.$refs.selectsearch
            }
            const shouldAutoFocusOnSearchInput = () => {
                return this.searchable && getSearchInput() && this.autoFocus
            }
            const focusOnSearchInput = () => {
                setTimeout(function () {
                    getSearchInput().focus();
                }, 100);
            }

            this.clearSearch();

            if (wasMenuClosed()) {
                if (this.hasValueChanged()) {
                    this.emitInput(this.valueCopy, !this.lazy)
                }
            }
            else if (wasMenuOpened()){
                this.valueCopy = deepClone(this.value)
                this.itemsCopy = this.getFilteredAndSortedItems(this.itemsCopy)
                if (shouldAutoFocusOnSearchInput()){
                    focusOnSearchInput()
                }
            }
            
        }
    },
    created() {
        this.valueCopy = deepClone(this.value)
    },
    beforeMount() {
        this.updateFriendlyLabel(this.value)
    },
    beforeDestroy() {
        if (this.menuState){
            this.updateMenuState(false)
        }
    },
    methods: {
        updateMenuState(event){
            this.$emit('update:menuState', event)
        },
        hasValueChanged() {

            if (Array.isArray(this.value) && !this.valueCopy.length && !this.value.length) {
                return false;
            }
            let new_values = this.valueCopy.map((val) => {
                if (typeof val === 'string') {
                    return val
                } else if (typeof val === 'object') {
                    val = val[this.valueKey]
                    // person_id_list as value as array
                    if (Array.isArray(val)) {
                        return JSON.stringify(val)
                    }
                    return val
                }
            })

            let original_values = this.value.map((val) => {
                if (typeof val === 'string') {
                    return val
                } else if (typeof val === 'object') {
                    val = val[this.valueKey]
                    // person_id_list as value as array
                    if (Array.isArray(val)) {
                        return JSON.stringify(val)
                    }
                    return val
                }
            })
            let difference1 = original_values.filter(x => !new_values.includes(x));
            let difference2 = new_values.filter(x => !original_values.includes(x));
            let diff = difference1.length + difference2.length;

            return diff > 0
        },
        sortGroups(items) {
            items.sort((a, b) => {
                let a_index = a.type ? a.type === 'group' : 0
                let b_index = b.type ? b.type === 'group' : 0

                if (a_index > b_index){
                    return -1
                } else if (a_index < b_index){
                    return 1
                }

                return 0
            });

            return items
        },
        isSortValueCurrentPersonSelected(check, value) {
            if (Array.isArray(check)) {
                if (JSON.stringify(check) === JSON.stringify(value)) {
                    return true
                }
            } else {
                if (check === value) {
                    return true
                }
            }

            return false
        },
        isSortValueSelected(value) {
            if (Array.isArray(value)) {
                if (this.valueCopy.findIndex(val => JSON.stringify(val[this.valueKey]) === JSON.stringify(value)) > -1) {
                    return true
                }
            } else {
                if (this.valueCopy.findIndex(val => val[this.valueKey] === value) > -1) {
                    return true
                }
            }

            return false
        },
        getFilteredAndSortedItems(items) {
            if (!items.length) {
                return [];
            }
            let filtered = items.filter(i => {
                if (!this.search) {
                    return true;
                }
                return String(this.itemName(i))
                    .toLowerCase()
                    .includes(this.search.toLowerCase());
            });

            filtered = filtered.sort((a, b) => a.name && b.name ? a.name.localeCompare(b.name) : 0)
            filtered = this.sortGroups(filtered)
            if (this.showSelectedFirst && this.multi) {
                /**
                 * Sort items by selected
                 */
                filtered.sort((a, b) => {
                    let a_index = -1
                    let b_index = -1

                    // Sort by selected, current user, groups, members
                    // Probably better to refactor this at some point when I get a better idea on how to do so
                    if (this.currentAccountId) {
                        if (this.isSortValueCurrentPersonSelected(a[this.valueKey], [this.currentAccountId])) {
                            a_index = 1
                            b_index = -1
                        } else if (this.isSortValueCurrentPersonSelected(b[this.valueKey], [this.currentAccountId])) {
                            a_index = -1
                            b_index = 1
                        }
                    }

                    // Sort selected
                    if (this.isSortValueSelected(a[this.valueKey])) {
                        a_index = 1
                        b_index = -1
                    } else if (this.isSortValueSelected(b[this.valueKey])) {
                        a_index = -1
                        b_index = 1
                    }

                    if (this.currentAccountId) {
                        if (this.isSortValueSelected(a[this.valueKey]) && this.isSortValueCurrentPersonSelected(a[this.valueKey], [this.currentAccountId])) {
                            a_index = 1
                            b_index = -1
                        } else if (this.isSortValueSelected(b[this.valueKey]) && this.isSortValueCurrentPersonSelected(b[this.valueKey], [this.currentAccountId])) {
                            a_index = -1
                            b_index = 1
                        }
                    }

                    if (a_index > -1 && b_index > -1){
                        return a_index - b_index
                    } else if (a_index > -1){
                        return -1
                    } else if (b_index > -1){
                        return 1
                    } else {
                        return 0
                    }
                });
            }

            return filtered;
        },
        toggleAllSelected() {
            const all = [].concat(this.itemsCopy);
            this.emitInput(all, this.lazy)
        },
        toggleAllUnselected() {
            this.emitInput([], this.lazy)
        },
        clearSearch() {
            this.search = "";
        },
        updateFriendlyLabel(value) {
            let friendly_label = ""
            if (Array.isArray(value)) {
                if (value.length > parseInt(this.showLabelCountFrom)) {
                    if (!this.multi) {
                        friendly_label = value[0][this.nameKey];
                    } else {
                        friendly_label = value.length.toString()
                    }
                } else {
                    if (this.filterKey === "person_id_list" || this.filterKey === "default_person_id_list") {
                        friendly_label = value.map(x => getShortName(x[this.nameKey])).join(', ');
                    } else {
                        friendly_label = value.map(x => x[this.nameKey]).join(', ');
                    }
                }
            } else if (typeof value === 'object' && value !== null) {
                friendly_label = value[this.nameKey];
            } else {
                friendly_label = value;
            }
            this.$emit("friendly_label", friendly_label);

        },
        select(item) {
            let ret = null
            if (this.multi && Array.isArray(this.valueCopy)) {
                const valueKey = this.valueKey;
                let selectedItemCurrentIndex = this.valueCopy.findIndex(x => x[valueKey] === item[valueKey]);
                if (selectedItemCurrentIndex === -1) {
                    selectedItemCurrentIndex = this.valueCopy.findIndex(
                        x => Array.isArray(x[valueKey]) && x[valueKey].filter(z => item[valueKey].includes(z)).length)
                }

                if (this.deselect && selectedItemCurrentIndex > -1) {
                    const copy = [].concat(this.valueCopy);
                    copy.splice(selectedItemCurrentIndex, 1);
                    ret = copy
                } else {
                    ret = this.valueCopy.concat(item)
                }
            } else if (this.deselect && this.valueCopy.find(x => x[this.valueKey] === item[this.valueKey])) {
                ret = []
            } else {
                ret = [item]
            }

            this.emitInput(ret, this.lazy)
            this.updateFriendlyLabel(ret)

            if (this.isSingleSelectDropDown()) {
                this.close()
            }

        },
        emitInput(val, lazy = false) {
            this.valueCopy = val
            if (lazy) return;
            this.$emit("input", this.valueCopy);
        },
        close(){
            this.$emit('update:menuState', false)
        },
        onConfirmClick() {
            this.$emit("confirm", this.valueCopy);
        },
        isSingleSelectDropDown(){
            return !this.multi
        },
        isSelected(item) {
            if (this.reverseSelect) {
                if (this.customRules) return !this.customRules(item, this.itemsCopy);
                if (typeof item === "string") {
                    return !this.valueCopy.some(value => String(value).toLowerCase() === String(item).toLowerCase());
                }
                else if (typeof item === "object") {
                    return !this.valueCopy.some(
                        value => String(value[this.valueKey].toLowerCase()) === String(item[this.valueKey]).toLowerCase()
                    );
                }
            } else {
                if (this.customRules) return this.customRules(item, this.itemsCopy);
                if (typeof item === "string") {
                    return this.valueCopy.some(s => String(s).toLowerCase() === String(item).toLowerCase());
                } else if (typeof item === "object") {
                    if (Array.isArray(item[this.valueKey])) {
                        let value = this.valueCopy.some(
                            values =>
                                values !== null &&
                                values[this.valueKey].filter(value => item[this.valueKey].includes(value)).length
                        );

                        return value;
                    }

                    return this.valueCopy.some(
                        value =>
                            value !== null &&
                            String(value[this.valueKey]).toLowerCase() === String(item[this.valueKey]).toLowerCase()
                    );
                }
            }
        },
        itemName(item) {
            if (typeof item === "string") {
                return item;
            } else if (typeof item === "object") {
                if (this.nameKey) {
                    return item[this.nameKey];
                } else if (this.valueKey) {
                    return item[this.valueKey];
                } else return "object keys undefined";
            }
        },
        isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
        }
    }
};

const getShortName = function (name) {
    // "FirstName MiddleName LastName".split(" ").map((n,i,a)=> i === 0 || i+1 === a.length ? n[0] : null).join("");
    let a = name ? name.split(" ") : '-';
    return a.length >= 2 ? (a[0] + " " + a[a.length - 1].charAt(0).toUpperCase()) : a[0];
}

</script>